<section class="product-detail-container">
  <div class="content">
    <ion-img
      class="not-found-img"
      id="box-dimension-search-img"
      src="assets/images/box-dimension-search.svg"
      [attr.data-cy]="'product-detail-non-found-box-img-image'"
    ></ion-img>
    <div
      data-cy="product-not-found-description-text"
      class="description-row bold"
    >
      {{ 'i18n.productDetail.notFoundPage.descriptionText' | translate }}
    </div>
    <div [attr.data-cy]="'product-not-found-text'" class="recommend-row">
      {{ 'i18n.productDetail.notFoundPage.recommendText' | translate }}
    </div>
    <ion-button
      class="usf-fill-green-button"
      data-cy="go-home-page"
      (click)="goToHome()"
      >{{
        'i18n.productDetail.notFoundPage.goToHomePage' | translate
      }}</ion-button
    >
  </div>
</section>
